import * as yup from 'yup'
import { AnyObject } from 'yup/lib/types'

/**
 * Enhances yup.string() with the possibility to pass 2 generic parameters:
 * - The type of the string, which can be a union type to restrict the typing
 * - The type of the context of the field
 *
 * @returns a yup.string constructor
 */
export const yupString = <
  T extends string = string,
  K extends AnyObject = AnyObject
>() => new yup.StringSchema<T, K>()
